import config from '../../config/config';
import DefaultApiLimit from '../../config/defaultLimit';
import {
  DeviceDetails,
  DeviceDetailsEdit,
  DevicePointsRequestInterface,
} from '../../interface/device-management.interface';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';
// import postStream from './base/postStream';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Add device API
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  addDevice: (data: DeviceDetails): Promise<any> => {
    return postRequest(`${config.commonApiUrl}api/facility/v1/charging-point`, data);
  },
  /**
   * Edit device API
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  editDevice: (data: DeviceDetailsEdit, id: string): Promise<any> => {
    return patchRequest(`${config.commonApiUrl}api/facility/v1/charging-point/${id}`, data);
  },
  /**
   * edit device connect points status API
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  editDeviceConnectPointsStatus: (
    data: { connectors: DevicePointsRequestInterface[] },
    id: string,
  ): Promise<any> => {
    return patchRequest(
      `${config.commonApiUrl}api/facility/v1/charging-point/connector/${id}`,
      data,
    );
  },
  /**
   * Edit station status API
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  editAvailableStatusDevice: (id: string, data: any): Promise<any> => {
    return patchRequest(
      `${config.commonApiUrl}api/facility/v1/charging-point/status/${id}`,
      data,
      false,
    );
  },
  /**
   * Reset device API
   * @param data
   */
  resetDevice: (data: any): Promise<any> => {
    return postRequest(`${config.ocppApiUrl}api/ocpp16/v1/facility/remote-reset-cp`, data);
  },
  /**
   * Fetch devices API
   * @param query
   */
  fetchDevices: (query: QueryParameters = {}) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/`, {
      ...parameters,
    });
  },
  /**
   * Fetch devices API for export
   * @param query
   */
  fetchDevicesExport: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/export-data`, {
      ...parameters,
    });
  },
  /**
   * Fetch all device api
   * @param stationId
   */
  fetchAllDevicesList: (stationId: string | number) => {
    return getRequest(
      `${config.commonApiUrl}api/facility/v1/charging-point/station/${stationId}`,
      {},
    );
  },
  /**
   * Fetch all device with details api
   * @param stationId
   */
  fetchAllDeviceDetailsList: (stationId: string | number) => {
    return getRequest(
      `${config.commonApiUrl}api/facility/v1/charging-point/station/device-details/${stationId}`,
      {},
    );
  },
  /**
   * Fetch all device model api
   * @param stationId
   */
  fetchAllDeviceModels: () => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/list-device-models`);
  },
  /**
   * Fetch all device api
   * @param stationId
   */
  fetchOneDevicePoints: (stationId: string | number) => {
    return getRequest(
      `${config.commonApiUrl}api/facility/v1/charging-point/connector/${stationId}`,
      {},
    );
  },
  /**
   * Delete device API
   * @param id
   */
  deleteDevice: (id: string): Promise<any> => {
    return deleteRequest(`${config.commonApiUrl}api/facility/v1/charging-point/${id}`);
  },
  /**
   * Fetch devices API
   * @param query
   */
  fetchListFilters: () => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/list-filters`);
  },
  /**
   * Get charging point details by Id
   */
  getChargingPointById: (id: string): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/${id}`);
  },
  /**
   * Fetching device image
   * @param deviceId
   * @returns
   */
  fetchDeviceImage: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-point-models/charge-point-metadata`, {
      ...parameters,
    });
  },
  /**
   * Fetch all device vendors
   * @param stationId
   */
  fetchAllChargePointVendors: () => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-point-models`);
  },
  /**
   * Fetch all charge point model
   * @param stationId
   */
  fetchAllChargePointModels: (chargePointVendor: string) => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-point-models/${chargePointVendor}`);
  },

  /**
   * Fetch subscriber connector limit
   */
  getSubscriptionConnecterLimit: () => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/get-subscription-connecter-limit`);
  },
};
